import { Button, Spinner } from "@nextui-org/react";
import { FileEarmarkSpreadsheet } from "react-bootstrap-icons";
import { ContractFilters } from "../interfaces/Contracts.interface";
import { getContractsExcel } from "../api/index.api";
import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { validateToken } from "../../../login/login";

const ExcelDownload:React.FC<{filters: ContractFilters}> = ({filters}) => {
    const [loading, setLoading] = useState(false);
    const { userInfo, setUserInfo, login } = useAuth();

    const downloadReport = async() => {
        setLoading(true);
        const user = await validateToken(userInfo, setUserInfo, login);
        const report = await getContractsExcel(user, filters);
        downloadExcelFile(report, "Listado de Contratos");
        setLoading(false);
    }

    return (
        <>
            {
            !loading ?
                <Button isIconOnly color="success" variant="solid" size="lg" title="Descargar en Excel" onPress={downloadReport}>
                    <FileEarmarkSpreadsheet size={20}/>
                </Button>
            :
                <Button isIconOnly color="success" variant="flat" size="lg" title="Descargando reporte" className="cursor-default">
                    <Spinner size="sm"/>
                </Button>
            }
        </>
    );
}

const downloadExcelFile = (base64Data: string, filename: string) => {
  const cleanedBase64 = base64Data.replace(/^data:.*;base64,/, '');
  const byteCharacters = atob(cleanedBase64);
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  // Creamos el Blob (tipo Excel)
  const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });

  // Creamos un enlace temporal
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;

  // Añadimos el enlace al DOM y simulamos el click
  document.body.appendChild(link);
  link.click();

  // Limpiamos al final
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};


export default ExcelDownload;